/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBitcoinHoldingsRewardSummary} from '../api'

 export const useQueryGetBitcoinHoldingsRewardSummary = createReactQueryHook('getBitcoinHoldingsRewardSummary', getBitcoinHoldingsRewardSummary)
